export const getEventColorStyle = (event_type, status) => {
  switch (event_type) {
    case "check_in":
      return "#1f78b4";

    case "check_out":
      return "#e31a1c";

    case "log_out":
      return "#cab2d6";

    case "log_in":
      return "#cab2d6";

    case "log_response":
      return "#6a3d9a";

    case "site_contact_attempt":
      return "#ff7f00";

    case "create_site":
      return "#ffbe00";

    case "door_canvass":
      return status ? getStatusColorStyle(status) : "#33a02c";

    case "training_start":
      return "#fdbf6f";

    case "training_end":
      return "#b15928";

    default:
      return "#444444";
  }
};

export const getStatusColorStyle = (status) => {
  switch (status) {
    case "canvass":
      return "#33a02c";
    case "not_home":
      return "#ff7f00";
    case "inaccessible":
      return "#e31a1c";
    case "moved":
      return "#e31a1c";
    case "refused":
      return "#ff7f00";
    default:
      return "black";
  }
};

export const getColorByModulo = (id) => {
  const colors = [
    "#1f78b4",
    "#cab2d6",
    "#33a02c",
    "#fb9a99",
    "#a6cee3",
    "#e31a1c",
    "#fdbf6f",
    "#ff7f00",
    "#6a3d9a",
    "#b2df8a",
    "#b15928",
  ];

  if (+id === NaN) return colors[0];

  return colors[+id % colors.length];
};
